import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getPriceQueryParams } from "../../helpers/Helpers.js";
import { PRODUCT_CATEGORIES } from "../../constants/constants.js";

const Filters = ({ forceInline = false }) => {
    const [min, setMin] = useState("");
    const [max, setMax] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedRating, setSelectedRating] = useState(null);
    const [isNarrow, setIsNarrow] = useState(false);

    const navigate = useNavigate();
    let [searchParams] = useSearchParams();

    // Sync UI state from URL when params change
    useEffect(() => {
        if (searchParams.has("price[gte]")) {
            setMin(searchParams.get("price[gte]"));
        } else {
            setMin(""); // clear if param removed
        }

        if (searchParams.has("price[lte]")) {
            setMax(searchParams.get("price[lte]"));
        } else {
            setMax(""); // clear if param removed
        }

        const urlCategory = searchParams.get("category");
        setSelectedCategory(urlCategory || null);

        const urlRatings = searchParams.get("ratings");
        setSelectedRating(urlRatings ? Number(urlRatings) : null);
    }, [searchParams]); // run when searchParams change

    useEffect(() => {
        const onResize = () => setIsNarrow(window.innerWidth <= 820);
        onResize();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // (Mobile modal owned by Home.jsx)

    // Handle price filter
    const handleButtonClick = (e) => {
        e.preventDefault();

        // reset pagination when filters change
        searchParams.delete("page");
        // clear keyword to avoid over-restricting results
        searchParams.delete("keyword");

        if (min) {
            searchParams = getPriceQueryParams(searchParams, "price[gte]", min);
        } else {
            searchParams.delete("price[gte]");
        }

        if (max) {
            searchParams = getPriceQueryParams(searchParams, "price[lte]", max);
        } else {
            searchParams.delete("price[lte]");
        }

        // keep filters sidebar visible
        searchParams.set("filters", "1");
        const path = window.location.pathname + "?" + searchParams.toString();
        navigate(path);
    };

    // Handle category filter
    const handleCategoryChange = (category) => {
        let newCategory = selectedCategory === category ? null : category;
        setSelectedCategory(newCategory);

        // reset pagination when filters change
        searchParams.delete("page");
        // clear keyword to avoid over-restricting results
        searchParams.delete("keyword");

        if (newCategory === null) {
            searchParams.delete("category");
        } else {
            searchParams.set("category", newCategory);
        }

        // keep filters sidebar visible
        searchParams.set("filters", "1");
        const path = window.location.pathname + "?" + searchParams.toString();
        navigate(path);
    };

    // Small helper to check URL-driven defaults for checkboxes
    const defaultCheckHandler = useMemo(() => {
        return (checkboxType, checkboxValue) => {
            const value = searchParams.get(checkboxType);
            if (value == null) return false;
            return String(checkboxValue) === String(value);
        };
    }, [searchParams]);

    // ✅ Handle rating filter (toggle on/off)
    const handleRatingChange = (rating) => {
        // reset pagination when filters change
        searchParams.delete("page");
        // clear keyword to avoid over-restricting results
        searchParams.delete("keyword");

        if (selectedRating === rating) {
            setSelectedRating(null);
            searchParams.delete("ratings");
        } else {
            setSelectedRating(rating);
            searchParams.set("ratings", rating);
        }
        // keep filters sidebar visible
        searchParams.set("filters", "1");
        const path = window.location.pathname + "?" + searchParams.toString();
        navigate(path);
    };

    

    return (
        <>
            <div className="filters-card shadow-sm p-4" style={isNarrow && !forceInline ? { display: "none" } : undefined}>
            <h3 className="filters-title mb-3">Filters</h3>
            <hr />

            {/* Price */}
            <h5 className="mb-3 filter-subheading">Price</h5>
            <form id="filter_form" className="px-1" onSubmit={handleButtonClick}>
                <div className="row g-2">
                    <div className="col">
                        <input
                            type="text"
                            className="form-control filter-input"
                            placeholder="Min"
                            name="min"
                            value={min}
                            onChange={(e) => setMin(e.target.value)}
                        />
                    </div>
                    <div className="col">
                        <input
                            type="text"
                            className="form-control filter-input"
                            placeholder="Max"
                            name="max"
                            value={max}
                            onChange={(e) => setMax(e.target.value)}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <button type="submit" className="btn filter-btn w-100">
                            Apply
                        </button>
                    </div>
                </div>
            </form>

            <hr />

            {/* Category */}
            <h5 className="mb-3 filter-subheading">Category</h5>
            {PRODUCT_CATEGORIES?.map((category, index) => (
                <div className="form-check" key={index}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`cat-${index}`}
                        checked={defaultCheckHandler("category", category)}
                        onChange={() => handleCategoryChange(category)}
                    />
                    <label className="form-check-label" htmlFor={`cat-${index}`}>
                        {category}
                    </label>
                </div>
            ))}

            <hr />

            {/* Ratings */}
            <h5 className="mb-3 filter-subheading">Ratings</h5>
            {[5, 4, 3, 2, 1].map((rating) => (
                <div className="form-check" key={rating}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`r-${rating}`}
                        checked={defaultCheckHandler("ratings", String(rating))}
                        onChange={() => handleRatingChange(rating)}
                    />
                    <label className="form-check-label text-warning" htmlFor={`r-${rating}`} >
                        {"★".repeat(rating) + (rating < 5 ? "☆" : "")}
                    </label>
                </div>
            ))}
        </div>

            
        </>
    );
};

export default Filters;

  